<template>
  <div class="inspection-list-container">
    <div class="jc-page-top">
      <div class="equipment-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('text.regionInspection')}}
          </h1>
          <div class="jc-box-action">
            <a v-bind:href="Config.REGION_iNSPECTION_URL" this="_blank">{{$t('equipment.helpDoc',[$t('text.regionInspection')])}}</a>
          </div>
        </div>

        <div class="jc-page-content">
          <div class="el-container-table common-table-container">
            <!-- 表头操作 -->
            <div class="el-container-table-actionBar">
              <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
                <el-form-item class="set-icon">
                  <el-button icon="jc-icon-refresh-line" class="el-button-icon" @click="getRegionList(cacheParams, true)"></el-button>
                </el-form-item>
                <el-form-item class="set-icon">
                  <el-button icon="el-icon-setting" class="el-button-icon" @click="customVisible = true" :title="$t('merge.customList')"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button class="el-button-icon" icon="jc-icon-download" @click="exportList" :title="$t('speechcraft.exportResourceList')"></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-table-actionBar-item" :inline="true">
                <div style="margin-top:8px;display:inline-block">{{$t('text.inspectionDate')}}：</div>
                <el-form-item>
                  <el-date-picker class="bill-list-toolbar-select"
                    v-model="checkDate"
                    type="daterange"
                    @change="changeDate"
                    :editable="false"
                    :clearable="true"
                    :start-placeholder="$t('text.start_placeholder')"
                    :end-placeholder="$t('text.end_placeholder')">
                  </el-date-picker>
                </el-form-item>
              </el-form>

                    <!-- :picker-options="pickerOptions" -->
            </div>
            <div class="el-container-table">
              <el-table
                  :data="regionListData"
                  class="product-table"
                  v-loading="refreshloading"
                  @filter-change="changeFilter"
                  :empty-text="tableEmptyTip">

              <el-table-column prop="checkDate" :label="$t('text.inspectionDate')"
                                :formatter="maybeEmpty"
                                v-if="getCustomInfoSelect('checkDate')"></el-table-column>
              <!-- 机房名称 -->
              <el-table-column prop="datacenterNameShow"
                                key="datacenterNameShow"
                                :label="$t('cabinet.roomName')"
                                :filter-multiple="true"
                                :filters="datacenterNameShowArr"
                                :filtered-value="filtersValue.datacenterName"
                                columnKey="datacenterName"
                                min-width="120"
                                show-overflow-tooltip
                                :filter-method="filtersRegion"
                                v-if="getCustomInfoSelect('datacenterNameShow')">
                <template slot-scope="scope">
                  <span>{{scope.row.datacenterNameShow | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="regionShow"
                               :label="$t('idcs.region')"
                               :formatter="maybeEmpty"
                               :filter-multiple="true"
                               :filters="fliter_region"
                               :filtered-value="filtersValue.regionEn"
                               columnKey="regionEn"
                               :filter-method="filtersRegion"
                               v-if="getCustomInfoSelect('regionShow')"> </el-table-column>
              <el-table-column prop="status" :label="$t('text.status')" :filter-multiple="false"
                               :filters="filterList.inspectionStatus"
                               :filtered-value="filtersValue.status"
                               columnKey="status"
                               :filter-method="filtersRegion" v-if="getCustomInfoSelect('status')">
                <template slot-scope="scope">

                  <span :class="scope.row.status == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.statusName | maybeEmpty}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="operate" :label="$t('text.operate')">
                <template slot-scope="scope">

                  <el-button type="text"
                              @click="showDetail(scope.row)"
                              size="small">{{$t('text.checkDetail')}}</el-button>

                </template>
                </el-table-column>
            </el-table>
            </div>

        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar" v-if="regionListData.length">
      <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
      <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
      <show-detail :visible.sync="detailVisible" v-if="detailVisible" :detailData="detailData"></show-detail>
    </div>
  </div>
</template>


<script>
import { cloneDeep } from 'lodash';
import moment from 'moment';
import custom from '../../common/custom/Custom.vue';
import showDetail from './showDetail';
import customInfoSelect from '@/mixins/customInfoSelect';

export default {
  components: {
    custom,
    showDetail
  },
  mixins: [customInfoSelect],
  data() {
    return {
      checkDate: [],
      fliter_region: [],
      datacenterNameShowArr: [],
      regionListData: [],
      currentPage: 1,
      pageSize: 20, // 默认每页20条
      pageSizes: [20, 50, 100], // 可选每页展示多少条
      total: 0,
      refreshLoading: false,
      tableEmptyTip: this.$t('text.noSearch'),
      tableEmptyMap: { // 表格提示文本
        search: this.$t('text.hasSearch'),
        noSearch: this.$t('text.noSearch')
      },
      // 自定义列表是否显示
      customVisible: false,
      // 自定义列表表头
      optionArr: [
        {
          label: this.$t('text.inspectionDate'),
          value: 'checkDate'
        }, {
          label: this.$t('cabinet.roomName'),
          value: 'datacenterNameShow'
        },
        {
          label: this.$t('idcs.region'),
          value: 'regionShow'
        },
        {
          label: this.$t('text.status'),
          value: 'status'
        },
        {
          label: this.$t('text.operate'),
          value: 'operation'
        }
      ],
      // 自定义列表类型
      type: 'idcInspection',
      detailVisible: false,
      detailData: null,
      filtersValue: {
        datacenterName: [],
        regionEn: [],
        status: []
      },
      cacheParams: null,
    };
  },
  methods: {
    getFilterRegion () {
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.idcs.length > 0 && res.data.idcs[0] != null) {
            const data = res.data.idcs;
            this.fliter_region = [];
            this.datacenterNameShowArr = [];
            for (let i = 0; i < data.length; i++) {
              this.fliter_region.push({
                value: data[i].regionEn,
                text: data[i].regionShow
              });
              this.datacenterNameShowArr.push({
                value: data[i].datacenterNameParam,
                text: data[i].datacenterNameShow
              });
            }
          } else {
            this.fliter_region = [];
            this.datacenterNameShowArr = [];
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    showDetail(data) {
      this.detailVisible = true;
      this.detailData = cloneDeep(data);
    },
    maybeEmpty (row, column) {
      const arr = row[column.property];
      const sign = '--';
      return arr || sign;
    },
    changeFilter (filter) {
      this.currentPage = 1;
      Object.keys(filter).forEach((key) => {
        this.filtersValue[key] = filter[key] || [];
      });
      const params = this.buildFilterParams();
      this.getRegionList(params, true);
    },
    changeDate(val) {
      this.currentPage = 1;
      this.getRegionList();
    },
    getRegionList (paramsArg = {}, search = false) {
      this.refreshloading = true;
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.checkDate !== null && this.checkDate[0]) {
        params.startDate = moment(this.checkDate[0]).format('YYYY-MM-DD').trim();
        params.endDate = moment(this.checkDate[1]).format('YYYY-MM-DD').trim();
      }
      const filterParams = this.buildFilterParams();
      params = Object.assign(params, filterParams, paramsArg);


      // month: moment(this.searchValueMap.accountPeriod).format('YYYY-MM').trim(),
      // productLine: this.GLOBAL.IDCLINE

      this.cacheParams = cloneDeep(params);
      this.$api.getIdcInspectionList(params).then((response) => {
        this.total = response.data.totalCount;
        this.refreshloading = false;
        if (response.data.idcInspections.length === 1 && response.data.idcInspections[0] === null) {
          this.regionListData = [];
        } else {
          this.regionListData = cloneDeep(response.data.idcInspections);
        }
        if (!this.regionListData.length) { // 数据为空时展示的内容
          if (!search) {
            this.tableEmptyTip = this.tableEmptyMap.search;
          } else {
            this.tableEmptyTip = this.tableEmptyMap.noSearch;
          }
        }
      }).finally(() => {
        this.refreshloading = false;
      });
    },
    exportList() {
      let url = '/ccs-api/api/inspection/exportIdcInspectionList?';
      const filterParams = this.buildFilterParams();
      const exportParams = { ...filterParams };
      if (this.checkDate !== null && this.checkDate[0]) {
        exportParams.startDate = moment(this.checkDate[0]).format('YYYY-MM-DD').trim();
        exportParams.endDate = moment(this.checkDate[1]).format('YYYY-MM-DD').trim();
      }
      Object.keys(exportParams).forEach((key, index) => {
        const value = exportParams[key];
        const valueStr = Array.isArray(value) ? value.join(',') : value;
        if (!index) {
          url += `${key}=${valueStr}`;
        } else {
          url += `&${key}=${valueStr}`;
        }
      });
      url += '&all=1';
      window.open(url, '_self');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // console.log(this.pageSize)
      this.getRegionList();
    },
    filtersRegion () {
      return true;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(this.currentPage)
      this.getRegionList();
    },
    getCustomInfo() {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((response) => {
        if (response.errno === 10000 && response.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: response.data.customInfo, type: this.type });
        }
      });
    },
    buildFilterParams () {
      const params = {};
      Object.keys(this.filtersValue).forEach((key) => {
        const value = this.filtersValue[key];
        const hasValue = Array.isArray(value) ? value.length > 0 : !!value;
        if (hasValue) {
          params[key] = Array.isArray(value) ? value.join(',') : value;
        }
      });
      return params;
    }
  },
  created() {
    this.getFilterRegion();
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
    this.getRegionList();
  },
  computed: {
    customInfo () {
      return this.$store.state.customInfo[this.type] || {};
    },
    filterList () {
      return this.$store.state.filter.filterList;
    },
    regionFilters () {
      const arr = [];
      if (this.filterList.idcNo) {
        this.filterList.idcNo.forEach((value) => {
          const obj = {
            value: value.value,
            text: value.text.region
          };
          arr.push(obj);
        });
      }
      return arr;
    }
  },
  watch: {
  }
};
</script>
<style lang="scss">
.inspection-list-container {
  /* // 设置footer分页(勿动) */
  background-color: #f6fafd;
  height: 100% ;
  overflow: auto;

  //消除table滚动
  .el-table__body-wrapper {
    overflow: hidden !important;
  }

  .search-select-width {
    width: 130px !important;
    margin-right: 5px !important;
    margin-bottom: 10px !important;
  }

  .search-input-width {
    width: 260px !important;
  }

  .el-form-item__content{
    line-height:30px !important
  }
}
.right {
  float: right;
}

.width90 {
  width: 90px !important;
}

.pages a.firstpage i,
.pages a.lastpage i {
  background: transparent !important;
}

.custom-header:after {
  content: ".";
  clear: both;
  height: 0;
  display: block;
  visibility: hidden;
}

.custom-header li {
  margin-top: 20px;
  margin-bottom: 20px;
}

.custom-header li label {
  float: left;
  width: 30%;
  padding-top: 10px;
  padding-left: 40px;
}
/* 调tool-bar */
.el-input-group__append {
  border-radius: 0 3px 3px 0 !important;
}
button.jc-button.jc-button--default.search-icon {
  border-left-width: 0px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
// i.jc-icon-search {
//   color: #d1d9de;
// }
input.jc-input__inner {
  border-radius: 3px 0 0 3px;
}
.jc-form-item.set-icon {
  margin-right: 8px !important;
}
/* 统一自定义风格（勿动） */
.jc-dialog.jc-dialog--tiny {
  width: 400px !important;
}
.normal-color{
    color:#008000;
  }
  .abnormal-color{
    color:#ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/inspection/region/RegionList.vue